/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.resources.staff.assign.controllers', [
  'ui.grid',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.directive.cellInput',
  'acme.common.factory.notice'
])

.controller('ResourcesStaffAssignController', ['$scope', '$uibModal', 'ApiService', 'HelpersService', 'NoticeFactory', function($scope, $uibModal, ApiService, HelpersService, NoticeFactory) {

    $scope.gridLink = '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ui-sref="application.users.detail({ id: \'{{ row.entity.id }}\' })">{{row.getProperty(col.field)}}</a></div>';
    $scope.gridInstanceLink = '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ui-sref="application.resourcesInstances({ id: \'{{ row.entity.id }}\' })">{{row.getProperty(col.field)}}</a></div>';

    $scope.resourcesStaffAssign = {

      isUpdated: true,

      resourcesSummaries: [],
      resourceTemplates: [],
      selectedAssignedStaff: [],
      selectedUnassignedStaff: [],
      editedAssignedStaff: [],

      search: {},

      model: {},
      staffModel: {},
      assignedStaffModel: {},
      unassignedStaffModel: {},

      sortInfo: {
        columns: [],
        fields: [],
        directions: ['asc', 'desc']
      },
      multiSelectModal: {},

      selectedResourceTemplateId: '',

      defaultAssignmentColumns: [
        {
          field: 'firstName',
          displayName: 'FirstName',
          cellTemplate: $scope.gridInstanceLink,
          enableCellEdit: false
        },
        {
          field: 'lastName',
          displayName: 'Last Name',
          cellTemplate: $scope.gridInstanceLink,
          enableCellEdit: false
        }
      ],

      updateCache: [],
      assignmentFields: [],
      assignmentColumns: [],

      init: function() {
        $scope.$emit('Application::contentTitleChange', {
          title: 'Personnel Assignment'
        });

        $scope.$emit('Application::viewChange', { view: 'full' });

        $scope.$on('cellInputEdit', this.onCellInputEdit);
        $scope.$on('cellInputEditStart::modal', this.cellInputEditStartModal);

        $scope.$watch('resourcesStaffAssign.sortInfo.columns', function() {
          console.log('StaffAssignController -> $watch -> resourcesStaffAssign.sortInfo.columns', arguments);

        });
        $scope.$watch('resourcesStaffAssign.sortInfo.fields', function() {
          console.log('StaffAssignController -> $watch -> resourcesStaffAssign.sortInfo.fields', arguments);
        });

        $scope.$on('ngGridEventEndCellEdit', function () {
          console.log('ngGridEventEndCellEdit', arguments);
          if ($scope.resourcesStaffAssign.updateCache.length > 0) {
            $scope.resourcesStaffAssign.isUpdated = false;
            $scope.$apply();
          }
        });
        $scope.$on('ngGridEventStartCellEdit', function () {});

        $scope.$on('$destroy', this.onDestroy);
        this.initResources();
        this.assignmentColumns = this.defaultAssignmentColumns.slice(0);
      },

      initResources: function(id) {
        this.selectedResourceTemplateId = id || false;
        ApiService.resource.list('Staff')
          .then(this.initStaff)
          .then(this.initAssignedStaff)
          .then(this.initTemplates)
          .then(this.initResource);
      },

      initStaff: function(response) {
        $scope.resourcesStaffAssign.resourcesSummaries = response.data.summaries;

        $scope.resourcesStaffAssign.resourcesSummaries = $.each($scope.resourcesStaffAssign.resourcesSummaries, function(index, value) {
          var selected;

          if (!$scope.resourcesStaffAssign.selectedResourceTemplateId) {
            selected = (index === 0);
          }else{
            selected = ($scope.resourcesStaffAssign.selectedResourceTemplateId === value.id);
          }

          if (selected) {
            value.selected = true;
            $scope.resourcesStaffAssign.selectedResourceTemplateId = value.id;
          }else{
            value.selected = false;
          }
        });
        return ApiService.userProxy.list(HelpersService.getPaginator());
      },

      initAssignedStaff: function(response) {
        $scope.resourcesStaffAssign.unassignedStaffModel = response.data.payload;
        $scope.resourcesStaffAssign.staffModel = response.data.payload;
        return ApiService.resource.instances.list($scope.resourcesStaffAssign.selectedResourceTemplateId);
      },

      initTemplates: function(response) {
        $scope.resourcesStaffAssign.model = response.data.payload;
        $scope.resourcesStaffAssign.assignedStaffModel = $scope.resourcesStaffAssign.processStaff(response.data.payload);
        $scope.resourcesStaffAssign.updateUnassignedStaff();
        return $scope.resourcesStaffAssign.selectedResourceTemplateId;
      },

      initResource: function(id) {
        $scope.resourcesStaffAssign.getResourceTemplate(id);
      },

      getStaff: function () {
        ApiService.userProxy.list(HelpersService.getPaginator()).then(this.success.getStaff, this.error.getStaff);
      },

      getAssignedStaff: function() {
        ApiService.resource.instances.list(this.selectedResourceTemplateId).then(this.success.getAssignedStaff, this.error.getAssignedStaff);
      },

      getUnassignedStaff: function() {
        //ApiService.resource.list(this.selectedResourceTemplateId);
      },

      getResourceTemplates: function (filter) {
        this.summariesLoading = true;
        ApiService.resource.list(filter).then(this.success.getResourceTemplates, this.error.getResourceTemplates);
      },

      getResourceTemplate: function(id) {
        if (!this.resourcesSummaries[id]) {
          ApiService.resource.detail(id).then(this.success.getResourceTemplate, this.error.getResourceTemplate);
        }
      },

      getResourceSummaries: function() {
        return $scope.resourcesStaffAssign.resourcesSummaries;
      },

      updateField: function(index, id) {

      },

      processStaff: function(staff) {

        var i, ii,
            j, jj,
            rowUser = {},
            processed = [],
            firstName = '',
            lastName = '';

        for (i=0,ii=staff.length;i<ii;i++) {
          if  (staff[i].resourceUser) {
            firstName = staff[i].resourceUser.userFirstName;
            lastName = staff[i].resourceUser.userLastName;
          }

          rowUser = {
            id: staff[i].id,
            ownerId: staff[i].ownerId,
            firstName: firstName,
            lastName: lastName
          };

          if (staff[i].fields instanceof Array) {
            for (j=0,jj=staff[i].fields.length;j<jj;j++) {
              rowUser['id_' + staff[i].fields[j].fieldOrder] = HelpersService.getFieldValue(staff[i].fields[j]);
              console.log('StaffAssignController::processStaff -> rowUser', rowUser['id_' + staff[i].fields[j].fieldOrder]);
            }
          }
          console.log('StaffAssignController::processStaff -> rowUser', rowUser);

          processed.push(rowUser);
        }

        console.log('StaffAssignController::processStaff', processed);
        return processed;
      },

      selectResource: function(resource) {
        this.initResources(resource.id);
      },

      updateAssignmentColumns: function(data) {

        var i, ii,
            j, jj,
            field,
            cellValue,
            fieldType,
            fieldValue,
            cellTemplate,
            editableCellTemplate;

        console.log('StaffAssignController::updateAssignmentColumns', data);

        this.assignmentColumns = this.defaultAssignmentColumns.slice(0);
        console.log('StaffAssignController::updateAssignmentColumns -> this.defaultAssignmentColumns', this.defaultAssignmentColumns);
        console.log('StaffAssignController::updateAssignmentColumns -> this.assignmentColumns', this.assignmentColumns);


        if (data.fields instanceof Array && data.fields.length > 0) {
          // Clear out preserved data
          this.editedAssignedStaff = [];

          for (j=0,jj=this.assignedStaffModel.length;j<jj;j++) {
            this.editedAssignedStaff.push({
              id: this.assignedStaffModel[j].id,
              ownerId: this.assignedStaffModel[j].ownerId,
              firstName: this.assignedStaffModel[j].firstName,
              lastName: this.assignedStaffModel[j].lastName
            });
            for (i=0,ii=data.fields.length;i<ii;i++) {
              fieldValue = HelpersService.getFieldValue(data.fields[i]);
              fieldType = HelpersService.getFieldType(data.fields[i]);
              //console.log('StaffAssignController::unique', 'id_' + data.fields[i].fieldOrder, this.assignedStaffModel[j]);

              // Merge the template with the instance if it's an array value
              if (this.assignedStaffModel[j].hasOwnProperty('id_' + data.fields[i].fieldOrder)) {
                //console.log('StaffAssignController::updateAssignmentColumns -> hasValue', j, 'id_' + data.fields[i].fieldOrder, this.editedAssignedStaff[j]['id_' + data.fields[i].fieldOrder]);

                if (fieldType.type.indexOf('Array') > 0) {
                  console.log('StaffAssignController::unique');
                  this.editedAssignedStaff[j]['id_' + data.fields[i].fieldOrder] = this.assignedStaffModel[j]['id_' + data.fields[i].fieldOrder];
                  this.assignedStaffModel[j]['id_' + data.fields[i].fieldOrder] = HelpersService.unique(fieldValue, this.assignedStaffModel[j]['id_' + data.fields[i].fieldOrder]);
                }else if (!this.assignedStaffModel[j]['id_' + data.fields[i].fieldOrder]) {
                  this.assignedStaffModel[j]['id_' + data.fields[i].fieldOrder] = fieldValue;
                  this.editedAssignedStaff[j]['id_' + data.fields[i].fieldOrder] = fieldValue;
                }else{
                  this.editedAssignedStaff[j]['id_' + data.fields[i].fieldOrder] = this.assignedStaffModel[j]['id_' + data.fields[i].fieldOrder];
                  console.log('StaffAssignController::updateAssignmentColumns -> hasValue', j, 'id_' + data.fields[i].fieldOrder, this.editedAssignedStaff[j]['id_' + data.fields[i].fieldOrder]);
                }
              }

            }
          }

          console.log('StaffAssignController::unique', this.assignedStaffModel);


          // Clear out assignment field columns
          this.assignmentFields = [];
          //this.sortInfo.fields = [];

          for (i=0,ii=data.fields.length;i<ii;i++) {
            cellValue = HelpersService.getFieldValue(data.fields[i]);
            field = HelpersService.low(HelpersService.getFieldType(data.fields[i]).type);
            console.log('StaffAssignController::updateAssignmentColumns', cellValue);

            cellTemplate = '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a>{{ COL_FIELD }}<span data-ng-if="!COL_FIELD">Select One</a></div>';

            if (cellValue instanceof Array) {
              editableCellTemplate = '<div>';
              if (data.fields[i].multiSelect) {
                editableCellTemplate += '<a data-cell-input="multiSelect" data-ng-model="modalWatcher">Select Values</a>';
              }else{
                editableCellTemplate += '<select data-cell-input data-ng-model="COL_FIELD" data-ng-options="field as field for field in resourcesStaffAssign.assignedStaffModel[ row.rowIndex ][\'id_'+data.fields[i].fieldOrder+'\']">';
                editableCellTemplate += '<option value="">Select One</option>';
                editableCellTemplate += '</select>';
              }
              editableCellTemplate += '</div>';
            }else{
              editableCellTemplate = '<div>';
              editableCellTemplate += '<input data-cell-input data-ng-model="COL_FIELD" />';
              editableCellTemplate += '</div>';
            }

            //this.sortInfo.fields.push('id_'+data.fields[i].fieldOrder);
            this.assignmentFields.push({
              field: 'id_'+data.fields[i].fieldOrder,
              displayName: data.fields[i].name,
              editableCellTemplate: editableCellTemplate,
              cellTemplate: cellTemplate
            });
          }

          this.assignmentColumns = this.assignmentColumns.concat(this.assignmentFields.slice(0));

        }

        this.resourceTemplates[data.id] = data;

      },

      updateUnassignedStaff: function() {
        var i, ii,
            j, jj,
            unassigned,
            unassignedStaff = [];

        for (i=0,ii=this.staffModel.length;i<ii;i++) {
          unassigned = true;
          for (j=0,jj=this.assignedStaffModel.length;j<jj;j++) {
            if (parseInt(this.staffModel[i].id, 10) === parseInt(this.assignedStaffModel[j].ownerId, 10)) {
              unassigned = false;
              console.log('StaffAssignController::updateUnassignedStaff -> unassigned', this.staffModel[i].id, this.assignedStaffModel[j].ownerId);
              break;
            }
          }

          if (unassigned) {
            unassignedStaff.push(this.staffModel[i]);
          }

        }
        console.log('StaffAssignController::updateUnassignedStaff', this.staffModel, unassignedStaff);
        this.unassignedStaffModel = unassignedStaff;
      },

      assign: function() {

        var i, ii,
            data = {
              resourceTemplateId: this.selectedResourceTemplateId,
              entityIds: []
            };

        for (i=0,ii=this.selectedUnassignedStaff.length;i<ii;i++) {
          data.entityIds.push(this.selectedUnassignedStaff[i].id);
        }

        console.log('StaffAssignController::assign', data);
        ApiService.resource.instances.batchCreate(data).then(this.success.batchCreate, this.error.batchCreate);

      },

      unassign: function() {
        ApiService.resource.instances.remove(this.selectedAssignedStaff).then(this.success.unassign, this.error.unassign);
      },

      update: function() {
        var i, ii;

        for (i=0,ii=this.updateCache.length;i<ii;i++) {
          ApiService.resource.instances.update(this.model[this.updateCache[i]]).then(this.success.update, this.error.update);
        }

      },

      success: {
        initResources: function(response) {
          $scope.resourcesStaffAssign.getStaff();
        },

        batchCreate: function(response) {
          console.log('StaffAssignController::success::batchCreate', response.payload);
          $scope.unassignedStaffGridOptions.selectAll(false);
          $scope.resourcesStaffAssign.initResources($scope.resourcesStaffAssign.selectedResourceTemplateId);
        },

        unassign: function(response) {

        },

        update: function(response) {
          $scope.resourcesStaffAssign.updateCache = [];
          $scope.resourcesStaffAssign.isUpdated = true;
        },

        getStaff: function(response) {
          $scope.resourcesStaffAssign.unassignedStaffModel = response.data.payload;
          $scope.resourcesStaffAssign.staffModel = response.data.payload;
        },

        getUnassignedStaff: function(response) {
          $scope.resourcesStaffAssign.unassignedStaffModel = response.data.payload;
        },

        getAssignedStaff: function(response) {
          console.log('StaffAssignController::getAssignedStaff');
          $scope.resourcesStaffAssign.assignedStaffModel = $scope.resourcesStaffAssign.processStaff(response.data.payload);
          $scope.resourcesStaffAssign.updateUnassignedStaff();

        },

        getResourceTemplates: function(response, status, headers, config) {
          $scope.resourcesStaffAssign.summariesLoading = false;
          $scope.resourcesStaffAssign.resourcesSummaries = response.data.summaries;
          $scope.resourcesStaffAssign.selectResource($scope.resourcesStaffAssign.resourcesSummaries[0]);
        },

        getResourceTemplate: function(response) {
          $scope.resourcesStaffAssign.updateAssignmentColumns(response.data.resourceType);
        }
      },

      error: {

        initResources: function(response) {},

        batchCreate: function(response) {

        },

        getStaff: function(response) {

        },

        update: function(response) {

        },

        getUnassignedStaff: function(response) {

        },

        getAssignedStaff: function(response) {

        },

        getResourceTemplates: function(response, status, headers, config) {
          $scope.resourcesStaffAssign.summariesLoading = false;
        },

        getResourceTemplate: function(response) {

        }
      },

      onDestroy: function() {
        $scope.$emit('Application::viewChange', { view: 'sidebar' });
      },

      cellInputEditStartModal: function(e, data) {
        console.log('StaffAssignController::cellInputEditStartModal', data);
        var self = $scope.resourcesStaffAssign;

        self.multiSelectModal = $uibModal.open({
          templateUrl: 'common/includes/multiSelectModal.tpl.html',
          controller: ['$scope', '$uibModalInstance', 'ValidateService', 'NoticeFactory', function($scope, $uibModalInstance, ValidateService, NoticeFactory) {

            var i, ii,
                selected = false;

            // Populate possible values to the model for use in modal
            $scope.model = [];

            $scope.errors = [];

            $scope.fieldName = data.column.displayName;

            // Assign field values need selected in modal

            for (i=0,ii=self.assignedStaffModel[data.rowIndex][data.column.field].length;i<ii;i++) {
              if (self.editedAssignedStaff[data.rowIndex][data.column.field]) {
                // See if field value is selected
                if (self.editedAssignedStaff[data.rowIndex][data.column.field] instanceof Array) {
                  selected = (self.editedAssignedStaff[data.rowIndex][data.column.field].indexOf(self.assignedStaffModel[data.rowIndex][data.column.field][i]) !== -1);
                }
              }
              console.log('StaffAssignController::cellInputEditStartModal -> selected', self.assignedStaffModel[data.rowIndex][data.column.field][i], selected);
              $scope.model.push({
                name: self.assignedStaffModel[data.rowIndex][data.column.field][i],
                selected: selected
              });
            }

            $scope.hasErrors = function() {
              return ($scope.errors.length > 0);
            };

            $scope.done = function () {
              $uibModalInstance.close($scope.model);
            };

            $scope.cancel = function () {
              $uibModalInstance.dismiss('cancel');
            };

            $scope.success = function(response) {
              $uibModalInstance.close(response);
            };

          }]
        });

        // Invoked when modal completes with close(params)
        self.multiSelectModal.result.then(function (values) {

          var i, ii,
              fieldValues = [];

          for (i=0,ii=values.length;i<ii;i++) {
            if (values[i].selected) {
              fieldValues.push(values[i].name);
            }
          }

          self.editedAssignedStaff[data.rowIndex][data.column.field] = fieldValues;
          $scope.$broadcast('cellInputEdit', {
            rowIndex: data.rowIndex
          });

          console.log('StaffAssignController::cellInputEditStartModal::multiSelectModal::success', data.column.field, fieldValues, self.editedAssignedStaff);
        }, function () {
          // Do nothing
        });
      },

      onCellInputEdit: function(e, data) {
        var i, ii,
            self = $scope.resourcesStaffAssign;

        console.log('StaffAssignController::onCellInputEdit -> data', data);

        for (i=0,ii=self.model[data.rowIndex].fields.length;i<ii;i++) {
          // Reassign single value to field type value
          var fieldTypes = HelpersService.getFieldType(self.model[data.rowIndex].fields[i]),
              fieldKey = fieldTypes.simpleType + 'Value',
              fieldType = fieldTypes.simpleType + 'Type',
              altFieldKey = fieldTypes.simpleType + 'ArrayValue';

          if (self.model[data.rowIndex].fields[i].multiSelect) {
            // multiSelect fields are arrays so update the type
            fieldType = fieldTypes.simpleType + 'ArrayType';
            fieldKey = fieldTypes.simpleType + 'ArrayValue';
            altFieldKey = fieldTypes.simpleType + 'Value';
          }

          self.model[data.rowIndex].fields[i].type = HelpersService.cap(fieldType);
          self.model[data.rowIndex].fields[i][fieldKey] = self.editedAssignedStaff[data.rowIndex]['id_'+self.model[data.rowIndex].fields[i].fieldOrder];
          self.model[data.rowIndex].fields[i][altFieldKey] = null;
        }

        if (self.updateCache.indexOf(data.rowIndex) === -1) {
          self.updateCache.push(data.rowIndex);
        }

        console.log('StaffAssignController::onCellInputEdit -> model', self.model);
      }

    };

    $scope.assignedStaffGridOptions = {
      enableCellEdit: true,
      enableCellEditOnFocus: true,
      enableRowSelection: true,
      multiselect: true,
      paginate: false
    };

    $scope.unassignedStaffGridOptions = {
      paginate: false,
      enableRowSelection: true,
      multiselect: true,
      columnDefs: [
        {
          field: 'firstName',
          displayName: 'FirstName',
          cellTemplate: $scope.gridLink
        },
        {
          field: 'lastName',
          displayName: 'Last Name',
          cellTemplate: $scope.gridLink
        },
        {
          field: 'email',
          displayName: 'Email',
          cellTemplate: $scope.gridLink
        },
        {
          field: 'phoneNumber',
          displayName: 'Phone Number'
        },
        {
          field: 'title',
          displayName: 'Job Title'
        },
        {
          field: 'confirmed',
          displayName: 'Activated'
        },
        {
          field: 'onBoarded',
          displayName: 'Registered'
        }
      ],
      data: 'resourcesStaffAssign.unassignedStaffModel'
    };



    $scope.resourcesStaffAssign.init();

}]);